import React, { useEffect, useRef, useState } from "react";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import FloatLabel from "../../../UiComponents/FloatLabel/FloatLabel";
import { Formik, Form, Field } from "formik";
import {
  GetCompany,
  GetPolicyType,
  GetSubBookingCode,
  GetSubProduct,
  GetRTOLocationByCompanyID,
  PostReceivableConfig,
  UpdateReceivableConfig,
  GetVehicleMake,
  DeleteReceivableConfigById,
  filterRTOLocation,
} from "../../../Service/_index";
import CloseIcon from "@mui/icons-material/Close";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import { Select } from "antd";
import { filterOption, filterSort } from "../../../Shared/CommonConstant";
import Button from "@mui/material/Button";
import { ToastError } from "../../../UiComponents/Toaster/Toast";
import { DeleteIcon } from "../../../Resources/Icons/icons";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import Styles from "../../../UiComponents/Scss/AddPopup.module.scss";

const AddReceivableConfig = (props) => {
  const { selectedData, formType, setOpenDrawer, ActiveFunction } = props;
  let formRef = useRef();

  const initialValues = {
    companyId: "",
    bookingCodeId: "",
    productId: "",
    subProductId: "",
    policyTypeId: "",
    subBookingCodeId: "",
    PACover: "",
    CC: "",
    GVW: "",
    OD: "",
    TP: "",
    Net: "",
    product: "",
    bookingCode: "",
    userId: "",
    locationId: "",
    make: "",
    year: "ALL",
    ccfrom: "",
    ccto: "",
    gvwfrom: "",
    gvwto: "",
    yearfrom: "",
    yearto: "",
    seatingCapacity: "",
    odDisc: "",
  };

  //Changed by Arun
  if (selectedData._id) {
    initialValues.activeDate = "";
  }

  const UserName = sessionStorage.getItem("UserId");
  const [companyDetails, setCompanyDetails] = useState([]);
  const [bookingCodeDetails, setBookingCodeDetails] = useState([]);
  const [productDetails, setProductDetails] = useState([]);
  const [policyTypeDetails, setPolicyTypeDetails] = useState([]);
  const [locationDetails, setLocationDetails] = useState([]);
  const [resetValue, setResetValue] = useState(1);
  const [makeDetails, setMakeDetails] = useState([]);

  const [defaultLocationDetails, setDefaultLocationDetails] = useState(
    formType === "edit" ? selectedData?.locationId : []
  );
  const [bookingCodeValue, setBookingCodeValue] = useState(
    formType === "edit"
      ? selectedData?.bookingCode?.value +
      " - " +
      selectedData?.subBookingCode?.value
      : null
  );
  const [productValue, setProductValue] = useState(
    formType === "edit"
      ? selectedData?.product?.value + " - " + selectedData?.subProduct?.value
      : null
  );

  const [policyTypeValue, setPolicyTypeValue] = useState(
    formType === "edit" ? selectedData?.policyType?.value : null
  );
  const [companyValue, setCompanyValue] = useState(
    formType === "edit" ? selectedData?.company?.value : null
  );
  const [paCoverValue, setPaCoverValue] = useState(
    formType === "edit" ? selectedData?.PACover : null
  );
  const [makeValue, setMakeValue] = useState(
    // formType === "edit" ? selectedData?.make : null
    formType === "edit" ? selectedData?.vehicleMake?.value : null // Changes by Arun
  );

  const [ccValue, setCcValue] = useState(
    selectedData.CC === "ALL" ? "ALL" : formType === "add" ? "" : "Range"
  );
  const [gvwValue, setGvwValue] = useState(
    selectedData.GVW === "ALL" ? "ALL" : formType === "add" ? "" : "Range"
  );
  const [yearValue, setYearValue] = useState(
    selectedData.year === "ALL" ? "ALL" : formType === "add" ? "" : "Range"
  );
  const [openCcRangeBox, setOpenCcRangeBox] = useState(
    selectedData.CC === "ALL" ? false : formType === "add" ? false : true
  );
  const [openGvwRangeBox, setOpenGvwRangeBox] = useState(
    selectedData.GVW === "ALL" ? false : formType === "add" ? false : true
  );
  const [openYearRangeBox, setOpenYearRangeBox] = useState(
    selectedData.year === "ALL" ? false : formType === "add" ? false : true
  );
  const [saveandCreateNewBtn, setSaveandCreateNewBtn] = useState(false); //changes by sankarNagarajan
  useEffect(() => {
    if (formType === "edit") {
      Object.keys(initialValues).forEach((el) => {
        initialValues[el] = selectedData[el];
      });
      formRef.setFieldValue("filterId", selectedData?._id);
      formRef.setFieldValue("companyId", selectedData?.company?.id);
      formRef.setFieldValue("bookingCodeId", selectedData?.bookingCode?.id);
      formRef.setFieldValue("policyTypeId", selectedData?.policyType?.id);
      formRef.setFieldValue("productId", selectedData?.product?.id);
      formRef.setFieldValue(
        "subBookingCodeId",
        selectedData?.subBookingCode?.id
      );
      formRef.setFieldValue("make", selectedData?.make);
      formRef.setFieldValue("subProductId", selectedData?.subProduct?.id);
      if (selectedData?.CC !== "ALL") {
        const ccRangeValues = selectedData?.CC?.split(" TO ");
        formRef.setFieldValue("ccfrom", ccRangeValues[0]);
        formRef.setFieldValue("ccto", ccRangeValues[1]);
      }
      if (selectedData?.GVW !== "ALL") {
        const gvwRangeValues = selectedData?.GVW?.split(" TO ");
        formRef.setFieldValue("gvwfrom", gvwRangeValues[0]);
        formRef.setFieldValue("gvwto", gvwRangeValues[1]);
      }
      if (selectedData?.year !== "ALL") {
        const yearRangeValues = selectedData?.year?.split(" TO ");
        formRef.setFieldValue("yearfrom", yearRangeValues[0]);
        formRef.setFieldValue("yearto", yearRangeValues[1]);
      }
      // Set seatingCapacity and odDisc values
      formRef.setFieldValue("seatingCapacity", selectedData?.seatingCapacity || "");
      formRef.setFieldValue("odDisc", selectedData?.odDisc || "");
    }
    formRef.setFieldValue(initialValues);
  }, []);

  //changes by sankarNagarajan
  const deleteFunction = () => {
    DeleteReceivableConfigById(selectedData._id).then((res) => {
      ActiveFunction();
      setOpenDrawer(false);
    });
  };

  const paCoverDetails = [
    {
      label: "All",
      value: "all",
    },
    {
      label: "Yes",
      value: "yes",
    },
    {
      label: "No",
      value: "no",
    },
  ];
  const GetCompanyDetails = () => {
    GetCompany({ isAscending: true }).then((res) => {
      const modifiedCompanyDetails = res.data
        .map((e) => {
          if (e.isEnabled) {
            return {
              ...e,
              label: e.shortName,
              value: e._id,
            };
          } else {
            return null;
          }
        })
        .filter(Boolean);
      modifiedCompanyDetails.unshift({
        _id: "ALL",
        value: "ALL",
        shortName: "ALL",
        label: "ALL",
      }); //Changes by Arun
      // console.log("modifiedCompanyDetails ", modifiedCompanyDetails);
      setCompanyDetails(modifiedCompanyDetails);
    });
  };

  const GetBookingCodeDetails = () => {
    GetSubBookingCode({ isAscending: "combineData" }).then((res) => {
      const modifiedBookingCodeDetails = res.data
        .map((e) => {
          if (e.isEnabled) {
            return {
              ...e,
              label: e.bookingCode + " - " + e.subBookingCode,
              value: e._id,
            };
          } else {
            return null;
          }
        })
        .filter(Boolean);
      setBookingCodeDetails(modifiedBookingCodeDetails);
    });
  };

  const GetProductDetails = () => {
    GetSubProduct({ isAscending: "combineData" }).then((res) => {
      const modifiedProductDetails = res.data
        .map((e) => {
          if (e.isEnabled) {
            return {
              ...e,
              label: e.product + " - " + e.subProduct,
              value: e._id,
            };
          } else {
            return null;
          }
        })
        .filter(Boolean);
      setProductDetails(modifiedProductDetails);
    });
  };

  // vehicleMake added by gokul..
  const [productID, setProductID] = useState([]);
  const GetVehicleMakeDetails = () => {
    GetVehicleMake({ isAscending: true }).then((res) => {
      const modifiedVehicleMakeDetails = res.data
        .map((e) => {
          if (e.isEnabled) {
            return {
              ...e,
              label: e.vehicleMake,
              value: e._id,
            };
          } else {
            return null;
          }
        })
        .filter(Boolean);

      const filterData = modifiedVehicleMakeDetails.filter((item) =>
        // productID.includes(item.productID)
        // Changes by Arun
        productID.length > 0
          ? productID.includes(item.productID)
          : selectedData?.product?.id == item.productID
      );

      filterData.unshift({ _id: "ALL", label: "ALL", value: "ALL" }); // Changes by Arun

      setMakeDetails(filterData);
    });
  };

  useEffect(() => GetVehicleMakeDetails(), [productID]);

  const GetPolicyTypeDetails = () => {
    GetPolicyType({ isAscending: true }).then((res) => {
      const modifiedPolicyTypeDetails = res.data
        .map((e) => {
          if (e.isEnabled) {
            return {
              ...e,
              label: e.policyType,
              value: e._id,
            };
          } else {
            return null;
          }
        })
        .filter(Boolean);
      setPolicyTypeDetails(modifiedPolicyTypeDetails);
    });
  };

  const GetRtoLocationFunction = (id) => {
    GetRTOLocationByCompanyID(id).then((res) => {
      const response = filterRTOLocation(res?.data?.location || []);
      console.log("response :", response);
      setLocationDetails(response);
    });
  };

  useEffect(() => {
    GetCompanyDetails();
    GetBookingCodeDetails();
    GetProductDetails();
    GetPolicyTypeDetails();
  }, []);

  const onSubmit = (e) => {
    // console.log(e);
    // return true;
    e.createdBy = UserName;
    if (openCcRangeBox) {
      if (e.ccfrom && e.ccto) {
        e.CC = String(e.ccfrom + " to " + e.ccto);
      } else {
        ToastError("Enter CC range values");
      }
    } else {
      e.CC = "ALL";
    }
    if (openGvwRangeBox) {
      if (e.gvwfrom && e.gvwto) {
        e.GVW = String(e.gvwfrom + " to " + e.gvwto);
      } else {
        ToastError("Enter GVW range values");
      }
    } else {
      e.GVW = "ALL";
    }
    if (openYearRangeBox) {
      if (e.yearfrom && e.yearto) {
        e.year = String(e.yearfrom + " to " + e.yearto);
      } else {
        ToastError("Enter Year range values");
      }
    } else {
      e.year = "ALL";
    }
    if (e.CC && e.GVW && e.year) {
      if (
        e.policyTypeId &&
        e.companyId &&
        e.bookingCodeId &&
        e.productId &&
        e.PACover &&
        e.make &&
        e.CC &&
        e.GVW &&
        e.year
      ) {
        const ApiType =
          formType === "edit"
            ? UpdateReceivableConfig(e)
            : PostReceivableConfig(e);
        ApiType.then((res) => {
          if (!saveandCreateNewBtn) {
            ActiveFunction();
            setOpenDrawer(false);
          } else {
            setSaveandCreateNewBtn(false);
          }
        }).catch((err) => {
          console.log(err);
        });
      } else {
        ToastError("Enter All fields");
      }
    }
  }; //changes by sankarNagarajan

  const { Option } = Select;

  return (
    <>
      <div className="DrawerContainer">
        <Grid container className="DrawerHeader">
          <Grid item xs={6} sm={6}>
            <Typography>{`${formType === "add" ? "Add" : "Edit"
              } Receivable Configuration`}</Typography>
          </Grid>
          <Grid item xs={6} sm={6} className="d-flex justify-content-end">
            <CloseIcon
              onClick={() => setOpenDrawer(false)}
              sx={{
                cursor: "pointer",
                height: "18px",
                width: "18px",
                fontWeight: 600,
              }}
            />
          </Grid>
        </Grid>
        <Formik
          initialValues={initialValues}
          onSubmit={(values) => {
            onSubmit(values);
          }}
          innerRef={(ref) => {
            if (ref) {
              formRef = ref;
            }
          }}
        >
          {({ values, setFieldValue }) => (
            <Form>
              <div className={Styles.addContent}>
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={6}>
                    {/* <FloatLabel
                      label="Select Company"
                      value={values?.companyId}
                    > */}
                    <Typography
                      className={Styles.inputTitle}
                      sx={{ fontSize: "12px", mb: 1 }}
                    >
                      Company
                    </Typography>
                    <Autocomplete
                      className="AutoComplete_InputBox"
                      name="companyId"
                      options={companyDetails}
                      value={companyValue}
                      onChange={(e, v) => {
                        setFieldValue("companyId", v?._id);
                        setResetValue(resetValue + 1);
                        setFieldValue("locationId", null);
                        setDefaultLocationDetails([]);
                        setCompanyValue(v?.label);
                        GetRtoLocationFunction(v?._id);
                      }}
                      onInputChange={(e, v) => {
                        GetRtoLocationFunction(selectedData?.company?.id);
                      }}
                      clearIcon={false}
                      renderInput={(params) => (
                        <TextField {...params} placeholder="Select Company" />
                      )}
                      isOptionEqualToValue={(option, value) =>
                        option.label === value
                      }
                      renderOption={(props, option) => (
                        <li {...props} key={option._id}>
                          {option.shortName}
                        </li>
                      )}
                    />
                    {/* </FloatLabel> */}
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    {/* <FloatLabel label="Location" value={values.locationId}> */}
                    <Typography
                      className={Styles.inputTitle}
                      sx={{ fontSize: "12px", mb: 1 }}
                    >
                      Location
                    </Typography>
                    <Select
                      mode="multiple"
                      dropdownStyle={{ zIndex: 11000 }}
                      className="AutoComplete_InputBox"
                      style={{ borderRadius: "0px", height: "43px" }}
                      maxTagCount="responsive"
                      filterOption={filterOption}
                      filterSort={filterSort}
                      placeholder="Select Location"
                      onChange={(selectedValues) => {
                        setFieldValue("locationId", selectedValues);
                      }}
                      defaultValue={defaultLocationDetails}
                      key={resetValue}
                    >
                      {locationDetails.map((el) => (
                        <Option value={el.id} key={el.id}>
                          {el.value}
                        </Option>
                      ))}
                    </Select>
                    {/* </FloatLabel> */}
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    {/* <FloatLabel
                      label="Select Booking Code & Sub Booking Code"
                      value={values?.bookingCodeId}
                    > */}
                    <Typography
                      className={Styles.inputTitle}
                      sx={{ fontSize: "12px", mb: 1 }}
                    >
                      Booking Code & Sub Booking Code
                    </Typography>
                    {formType === "add" ? (
                      <Select
                        dropdownStyle={{ zIndex: 11000 }}
                        mode="multiple"
                        className="AutoComplete_InputBox"
                        style={{ borderRadius: "0px", height: "43px" }}
                        maxTagCount="responsive"
                        filterOption={filterOption}
                        filterSort={filterSort}
                        placeholder="Select Booking Code & Sub Booking Code"
                        onChange={(selectedValues) => {
                          try {
                            const parsedObjects = selectedValues.map((value) =>
                              JSON.parse(value)
                            );
                            const bookingCodeIds = parsedObjects
                              .filter((el) => el.bookingCodeId !== undefined)
                              .map((el) => el.bookingCodeId);
                            const SubbookingCodeIds = parsedObjects
                              .filter((el) => el._id !== undefined)
                              .map((el) => el._id);

                            const bookingCodeValues = parsedObjects.map(
                              (el) => ({
                                bookingCodeId:
                                  el.bookingCodeId !== undefined
                                    ? el.bookingCodeId
                                    : "",
                                subBookingCodeId:
                                  el._id !== undefined ? el._id : "",
                              })
                            );
                            setFieldValue(
                              "bookingCodeId",
                              bookingCodeValues.map((obj) => obj.bookingCodeId)
                            );
                            setFieldValue(
                              "subBookingCodeId",
                              bookingCodeValues.map(
                                (obj) => obj.subBookingCodeId
                              )
                            );
                            setFieldValue("bookingCode", bookingCodeValues);
                          } catch (error) {
                            console.error("Error parsing JSON:", error);
                          }
                        }}
                      >
                        {bookingCodeDetails.map((el) => (
                          <Option value={JSON.stringify(el)} key={el.value}>
                            {el.label}
                          </Option>
                        ))}
                      </Select>
                    ) : (
                      <Autocomplete
                        className="AutoComplete_InputBox"
                        name="companyId"
                        options={bookingCodeDetails}
                        value={bookingCodeValue}
                        onChange={(e, v) => {
                          setFieldValue("bookingCodeId", v?.bookingCodeId);
                          setFieldValue("subBookingCodeId", v?._id);
                          setBookingCodeValue(v?.label);
                        }}
                        clearIcon={false}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            placeholder="Select Booking Code & Sub Booking Code"
                          />
                        )}
                        isOptionEqualToValue={(option, value) =>
                          option.label === value
                        }
                      />
                    )}
                    {/* </FloatLabel> */}
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    {/* <FloatLabel
                      label="Select Product & Sub Product"
                      value={values?.productId}
                    > */}
                    <Typography
                      className={Styles.inputTitle}
                      sx={{ fontSize: "12px", mb: 1 }}
                    >
                      Product & Sub Product
                    </Typography>
                    {formType === "add" ? (
                      <Select
                        dropdownStyle={{ zIndex: 11000 }}
                        mode="multiple"
                        className="AutoComplete_InputBox"
                        style={{ borderRadius: "0px", height: "43px" }}
                        maxTagCount="responsive"
                        filterOption={filterOption}
                        filterSort={filterSort}
                        placeholder="Select Product"
                        onChange={(selectedValues) => {
                          try {
                            const parsedObjects = selectedValues.map((value) =>
                              JSON.parse(value)
                            );
                            const productValues = parsedObjects.map((el) => ({
                              productId:
                                el.productID !== undefined ? el.productID : "",
                              subProductId: el._id !== undefined ? el._id : "",
                            }));

                            setFieldValue(
                              "productId",
                              productValues.map((obj) => obj.productId)
                            );
                            setProductID(
                              productValues.map((obj) => obj.productId)
                            );
                            setFieldValue(
                              "subProductId",
                              productValues.map((obj) => obj.subProductId)
                            );
                            setFieldValue("product", productValues);
                          } catch (error) {
                            console.error("Error parsing JSON:", error);
                          }
                        }}
                      >
                        {productDetails.map((el) => (
                          <Option value={JSON.stringify(el)} key={el.value}>
                            {el.label}
                          </Option>
                        ))}
                      </Select>
                    ) : (
                      <Autocomplete
                        className="AutoComplete_InputBox"
                        name="productId"
                        options={productDetails}
                        value={productValue}
                        onChange={(e, v) => {
                          setFieldValue("productId", v?.productID);
                          setFieldValue("subProductId", v?._id);
                          setProductValue(v?.label);
                          setProductID(v?.productID);
                          // console.log(v);
                        }}
                        clearIcon={false}
                        renderInput={(params) => (
                          <TextField {...params} placeholder="Select Product" />
                        )}
                        isOptionEqualToValue={(option, value) =>
                          option.label === value
                        }
                      />
                    )}
                    {/* </FloatLabel> */}
                  </Grid>

                  <Grid item xs={12} sm={openCcRangeBox ? 2 : 6}>
                    <Typography
                      className={Styles.inputTitle}
                      sx={{ fontSize: "12px", mb: 1 }}
                    >
                      CC
                    </Typography>
                    <Autocomplete
                      className="AutoComplete_InputBox"
                      name="CC"
                      value={ccValue}
                      options={[{ label: "ALL" }, { label: "Range" }]}
                      clearIcon={false}
                      onChange={(e, v) => {
                        if (v?.label === "ALL") {
                          setCcValue(v.label);
                          setOpenCcRangeBox(false);
                          setFieldValue("ccfrom", "");
                          setFieldValue("ccto", "");
                        } else {
                          setCcValue(v.label);
                          setOpenCcRangeBox(true);
                        }
                      }}
                      renderInput={(params) => (
                        <TextField {...params} placeholder="Select CC" />
                      )}
                      isOptionEqualToValue={(option, value) =>
                        option?.label === value?.label
                      }
                    />
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={2}
                    sx={{ display: openCcRangeBox ? "block" : "none" }}
                  >
                    <Typography
                      className={Styles.inputTitle}
                      sx={{ fontSize: "12px", mb: 1 }}
                    >
                      CC Form
                    </Typography>
                    <Field
                      name="ccfrom"
                      placeholder="Enter"
                      className="InputFiled"
                      style={{ textTransform: "uppercase" }}
                    />
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={2}
                    sx={{ display: openCcRangeBox ? "block" : "none" }}
                  >
                    <Typography
                      className={Styles.inputTitle}
                      sx={{ fontSize: "12px", mb: 1 }}
                    >
                      CC To
                    </Typography>
                    <Field
                      name="ccto"
                      placeholder="Enter"
                      className="InputFiled"
                      style={{ textTransform: "uppercase" }}
                    />
                  </Grid>

                  <Grid item xs={12} sm={openGvwRangeBox ? 2 : 6}>
                    {" "}
                    <Typography
                      className={Styles.inputTitle}
                      sx={{ fontSize: "12px", mb: 1 }}
                    >
                      GVW
                    </Typography>
                    <Autocomplete
                      className="AutoComplete_InputBox"
                      name="GVW"
                      value={gvwValue}
                      options={[{ label: "ALL" }, { label: "Range" }]}
                      clearIcon={false}
                      onChange={(e, v) => {
                        if (v?.label === "ALL") {
                          setGvwValue(v.label);
                          setOpenGvwRangeBox(false);
                          setFieldValue("gvwfrom", "");
                          setFieldValue("gvwto", "");
                        } else {
                          setGvwValue(v.label);
                          setOpenGvwRangeBox(true);
                        }
                      }}
                      renderInput={(params) => (
                        <TextField {...params} placeholder="Select GVW" />
                      )}
                      isOptionEqualToValue={(option, value) =>
                        option?.label === value?.label
                      }
                    />
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={2}
                    sx={{ display: openGvwRangeBox ? "block" : "none" }}
                  >
                    <Typography
                      className={Styles.inputTitle}
                      sx={{ fontSize: "12px", mb: 1 }}
                    >
                      GVW Form
                    </Typography>
                    <Field
                      name="gvwfrom"
                      placeholder="Enter"
                      className="InputFiled"
                      style={{ textTransform: "uppercase" }}
                    />
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={2}
                    sx={{ display: openGvwRangeBox ? "block" : "none" }}
                  >
                    <Typography
                      className={Styles.inputTitle}
                      sx={{ fontSize: "12px", mb: 1 }}
                    >
                      GVW To
                    </Typography>
                    <Field
                      name="gvwto"
                      placeholder="Enter"
                      className="InputFiled"
                      style={{ textTransform: "uppercase" }}
                    />
                  </Grid>

                  <Grid item xs={12} sm={6}>
                    <Typography
                      className={Styles.inputTitle}
                      sx={{ fontSize: "12px", mb: 1 }}
                    >
                      Policy Type
                    </Typography>
                    {formType === "add" ? (
                      <Select
                        dropdownStyle={{ zIndex: 11000 }}
                        mode="multiple"
                        className="AutoComplete_InputBox"
                        style={{ borderRadius: "0px", height: "43px" }}
                        maxTagCount="responsive"
                        filterOption={filterOption}
                        filterSort={filterSort}
                        placeholder="Select Policy Type"
                        onChange={(selectedValues) => {
                          setFieldValue("policyTypeId", selectedValues);
                        }}
                      >
                        {policyTypeDetails.map((el) => (
                          <Option value={el._id} key={el.value}>
                            {el.label}
                          </Option>
                        ))}
                      </Select>
                    ) : (
                      <Autocomplete
                        className="AutoComplete_InputBox"
                        name="policyTypeId"
                        options={policyTypeDetails}
                        value={policyTypeValue}
                        onInputChange={(e, v) => setPolicyTypeValue(v)}
                        onChange={(e, v) => {
                          setFieldValue("policyTypeId", v?._id);
                          setPolicyTypeValue(v?.label);
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            placeholder="Select Policy Type"
                          />
                        )}
                        isOptionEqualToValue={(option, value) =>
                          option?.label === value
                        }
                      />
                    )}
                    {/* </FloatLabel> */}
                  </Grid>

                  <Grid item xs={12} sm={6}>
                    <Typography
                      className={Styles.inputTitle}
                      sx={{ fontSize: "12px", mb: 1 }}
                    >
                      PA Cover
                    </Typography>
                    {formType === !"edit" ? (
                      <Autocomplete
                        className="AutoComplete_InputBox"
                        name="PACover"
                        clearIcon={false}
                        options={paCoverDetails}
                        onChange={(e, v) => {
                          setFieldValue("PACover", v.value);
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            placeholder="Select PA Cover"
                          />
                        )}
                        isOptionEqualToValue={(option, value) =>
                          option?.label === value
                        }
                      />
                    ) : (
                      <Autocomplete
                        className="AutoComplete_InputBox"
                        name="PACover"
                        options={paCoverDetails}
                        value={paCoverValue}
                        onChange={(e, v) => {
                          setFieldValue("PACover", v?.value);
                          setPaCoverValue(v?.label);
                        }}
                        clearIcon={false}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            placeholder="Select PA Cover"
                          />
                        )}
                        isOptionEqualToValue={(option, value) =>
                          option.label === value
                        }
                      />
                    )}
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Typography
                      className={Styles.inputTitle}
                      sx={{ fontSize: "12px", mb: 1 }}
                    >
                      Make
                    </Typography>
                    {/* Changes by Arun */}
                    {formType === "edit" ? (
                      <Autocomplete
                        className="AutoComplete_InputBox"
                        name="make"
                        options={makeDetails}
                        value={makeValue}
                        // onInputChange={(e, v) => setMakeValue(v)}
                        onChange={(e, v) => {
                          // setFieldValue("make", v?.label);
                          setFieldValue("make", v?._id); //Changes by Arun
                          setMakeValue(v?.label);
                        }}
                        renderInput={(params) => (
                          <TextField {...params} placeholder="Select Make" />
                        )}
                        isOptionEqualToValue={(option, value) =>
                          option?.label === value
                        }
                      />
                    ) : (
                      <Select
                        mode="multiple"
                        dropdownStyle={{ zIndex: 11000 }}
                        className="AutoComplete_InputBox"
                        style={{ borderRadius: "0px", height: "43px" }}
                        maxTagCount="responsive"
                        filterOption={filterOption}
                        filterSort={filterSort}
                        placeholder="Select Make"
                        onChange={(selectedValues) => {
                          console.log(selectedValues);
                          setFieldValue("make", selectedValues);
                        }}
                      >
                        {makeDetails.map((el) => (
                          <Option value={el._id} key={el._id}>
                            {el.label}
                          </Option>
                        ))}
                      </Select>
                    )}
                  </Grid>
                  <Grid item xs={12} sm={openYearRangeBox ? 2 : 6}>
                    <Typography
                      className={Styles.inputTitle}
                      sx={{ fontSize: "12px", mb: 1 }}
                    >
                      Year
                    </Typography>
                    <Autocomplete
                      className="AutoComplete_InputBox"
                      value={yearValue}
                      options={[{ label: "ALL" }, { label: "Range" }]}
                      clearIcon={false}
                      onChange={(e, v) => {
                        if (v?.label === "ALL") {
                          setYearValue(v.label);
                          setOpenYearRangeBox(false);
                          setFieldValue("yearfrom", "");
                          setFieldValue("yearto", "");
                        } else {
                          setYearValue(v.label);
                          setOpenYearRangeBox(true);
                        }
                      }}
                      renderInput={(params) => (
                        <TextField {...params} placeholder="Select Year" />
                      )}
                      isOptionEqualToValue={(option, value) =>
                        option?.label === value?.label
                      }
                    />
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={2}
                    sx={{ display: openYearRangeBox ? "block" : "none" }}
                  >
                    <Typography
                      className={Styles.inputTitle}
                      sx={{ fontSize: "12px", mb: 1 }}
                    >
                      Year Form
                    </Typography>
                    <Field
                      type="number"
                      name="yearfrom"
                      placeholder="Enter"
                      className="InputFiled"
                      style={{ textTransform: "uppercase" }}
                    />
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={2}
                    sx={{ display: openYearRangeBox ? "block" : "none" }}
                  >
                    <Typography
                      className={Styles.inputTitle}
                      sx={{ fontSize: "12px", mb: 1 }}
                    >
                      Year To
                    </Typography>
                    <Field
                      type="number"
                      name="yearto"
                      placeholder="Enter"
                      className="InputFiled"
                      style={{ textTransform: "uppercase" }}
                    />
                  </Grid>

                  <Grid item xs={12} sm={6}>
                    <Typography
                      className={Styles.inputTitle}
                      sx={{ fontSize: "12px", mb: 1 }}
                    >
                      Seating Capacity
                    </Typography>
                    <Field
                      name="seatingCapacity"
                      placeholder="Enter Seating Capacity"
                      className="InputFiled"
                      type="number"
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Typography
                      className={Styles.inputTitle}
                      sx={{ fontSize: "12px", mb: 1 }}
                    >
                      OD Discount
                    </Typography>
                    <Field
                      name="odDisc"
                      placeholder="Enter OD Discount"
                      className="InputFiled"
                      type="number"
                    />
                  </Grid>

                  <Grid item xs={12} sm={4}>
                    <Typography
                      className={Styles.inputTitle}
                      sx={{ fontSize: "12px", mb: 1 }}
                    >
                      OD %
                    </Typography>{" "}
                    <Field
                      name="OD"
                      placeholder="Enter OD"
                      className="InputFiled"
                      style={{ textTransform: "uppercase" }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={4}>
                    <Typography
                      className={Styles.inputTitle}
                      sx={{ fontSize: "12px", mb: 1 }}
                    >
                      TP %
                    </Typography>
                    <Field
                      name="TP"
                      placeholder="Enter TP"
                      className="InputFiled"
                    />
                  </Grid>
                  <Grid item xs={12} sm={4}>
                    <Typography
                      className={Styles.inputTitle}
                      sx={{ fontSize: "12px", mb: 1 }}
                    >
                      NET %
                    </Typography>
                    <Field
                      name="Net"
                      placeholder="Enter NET"
                      className="InputFiled"
                      style={{ textTransform: "uppercase" }}
                    />
                  </Grid>
                  {/*changes by sankarNagarajan */}
                  <Grid item xs={12} sm={6}>
                    <Typography
                      className={Styles.inputTitle}
                      sx={{ fontSize: "12px", mb: 1 }}
                    >
                      Active Date
                    </Typography>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DatePicker
                        name="activeDate"
                        className="Date_Picker w-100"
                        value={dayjs(values?.activeDate)}
                        onChange={(e) => setFieldValue("activeDate", e?.$d)}
                        format={"DD/MM/YYYY"}
                      />
                    </LocalizationProvider>
                  </Grid>
                </Grid>
              </div>
              <div className="Dialog_Footer">
                <Button
                  onClick={() => setOpenDrawer(false)}
                  className="Dialog_Cancel"
                >
                  Cancel
                </Button>
                <Button
                  type="submit"
                  className={
                    formType === "add" ? "Dialog_Save" : "Dialog_Save_Exit"
                  }
                >
                  {selectedData?._id ? "Update" : "Save"}
                </Button>
                {/*changes by sankarNagarajan */}
                <Button
                  sx={{ display: selectedData?._id ? "none" : "display" }}
                  type="submit"
                  className="Dialog_Save_Exit"
                  onClick={() => setSaveandCreateNewBtn(true)}
                >
                  Save & Create New
                </Button>
                <Button
                  sx={{ display: selectedData?._id ? "inline-flex" : "none" }}
                  endIcon={<DeleteIcon />}
                  onClick={() => deleteFunction()}
                  className="Dialog_Cancel"
                >
                  Delete
                </Button>
              </div>
            </Form>
          )}
        </Formik>
      </div>
    </>
  );
};

export default AddReceivableConfig;
